module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaAQMAAACThN6NAAAABlBMVEX///8zptOUaBC2AAAAEElEQVQI12OgCPw/ACEoAQDjvwN/PjWeTQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_minus2_hover.png
// module id = V5Tq
// module chunks = 9